//@ts-ignore
import React from 'react';
import { find, noop } from 'lodash';

import { Menu, MenuLink, PlainButton, PopupButton } from 'components/shared';

interface SelectMenuProps {
  id: string;
  type?: string;
  arrow?: boolean;
  label?: React.ReactNode;
  value?: string;
  prefix?: string;
  disabled?: boolean;
  popupClassName?: string;
  options: SelectMenuOption[];
  onChange?: (option: SelectMenuOption, event: any) => void;
  anchored?: boolean;
  hideLabel?: boolean;
  className?: string;
  tooltipText?: string;
  defaultLabel?: string;
  closeOnClick?: boolean;
  menuClassName?: string;
  alwaysRender?: boolean;
  menuFullWidth?: boolean;
  buttonClassName?: string;
  buttonActiveClass?: string;
  onlyDisplayLogout?: boolean;
  showMenuCheckmarks?: boolean;
  horizontalPosition?: 'Right' | 'Center' | 'Left';
}

interface SelectMenuOption {
  key: string;
  value?: React.ReactNode;
  label?: string;
  props?: {
    to?: string;
    div?: string;
  };
  onClick?: (option: SelectMenuOption, event: any) => void;
}

export const SelectMenu: React.FC<SelectMenuProps> = ({
  id,
  type,
  label,
  arrow = true,
  anchored = false,
  alwaysRender = false,
  className,
  closeOnClick,
  buttonClassName,
  buttonActiveClass,
  defaultLabel = 'No selection',
  disabled,
  hideLabel = false,
  menuClassName,
  menuFullWidth,
  onChange = noop,
  onlyDisplayLogout,
  options = [],
  popupClassName,
  prefix = '',
  showMenuCheckmarks = false,
  tooltipText,
  value,
  ...props
}) => {
  const selected = find(options, { key: value });

  const isLinkSelected = (option: SelectMenuOption) => {
    return !!(selected && option.value === selected.value);
  };

  return (
    <PopupButton
      id={id}
      type={type}
      arrow={arrow}
      label={
        label ? (
          label
        ) : (
          <span>
            {prefix} {selected ? selected.label || selected.value : defaultLabel}
          </span>
        )
      }
      disabled={disabled}
      anchored={anchored}
      hideLabel={hideLabel}
      className={className}
      Component={PlainButton}
      tooltipText={tooltipText}
      alwaysRender={alwaysRender}
      closeOnClick={closeOnClick}
      popupClassName={popupClassName}
      buttonClassName={buttonClassName}
      buttonActiveClass={buttonActiveClass}
    >
      <Menu className={menuClassName} fullWidth={menuFullWidth} type={type} popup {...props}>
        {options.map((option) => (
          <MenuLink
            {...option.props}
            type={type}
            showMenuCheckmarks={showMenuCheckmarks}
            selected={isLinkSelected(option)}
            key={option.key}
            onClick={
              onChange && !(option.props && (option.props.to || option.props.div))
                ? (event: any) => onChange!(option, event)
                : null
            }
          >
            {option.value}
          </MenuLink>
        ))}
      </Menu>
    </PopupButton>
  );
};

export default SelectMenu;
